import React from 'react';

export default function ActionCount({ count, unknown = false }: { count: number; unknown?: boolean }) {
  if (!count && !unknown) return null;
  return <span
    className="shrink-0 min-w-[22px] rounded-full bg-amber-100 px-1.5 py-0.5 text-center text-[11px] font-bold text-amber-900"
    title={unknown ? 'Counts incomplete or unavailable' : `${count} pending actions`}
    aria-label={unknown ? `${count} known pending actions; counts incomplete` : `${count} pending actions`}
  >{count > 99 ? '99+' : count || ''}{unknown ? '?' : ''}</span>;
}
